/**
 * 평가사 상세 프로필 컴포넌트
 * InspectorManage.js에서 분리
 */
import React, { useState } from 'react';

// ─── 상수 ───
var LEVELS = {
  '마스터': { color: '#D85A30', bg: '#FAECE7', desc: '100건+ & 평점 4.5+', benefit: '검차비 +20%, 우선 콜' },
  '시니어': { color: '#534AB7', bg: '#EEEDFE', desc: '50건+ & 평점 4.0+', benefit: '검차비 +10%' },
  '일반':   { color: '#888780', bg: '#F1EFE8', desc: '기본', benefit: '기본 검차비' },
};

var LvBadge = function(props) {
  var level = props.level;
  var size = props.size || 'normal';
  var c = LEVELS[level] || LEVELS['일반'];
  var isSmall = size === 'small';
  return (
    <span style={{
      display: 'inline-block',
      padding: isSmall ? '1px 6px' : '3px 10px',
      borderRadius: 5,
      fontSize: isSmall ? 10 : 12,
      fontWeight: 600,
      color: c.color,
      background: c.bg,
    }}>{level}</span>
  );
};

var Stars = function(props) {
  var value = props.value || 0;
  var size = props.size || 14;
  return (
    <span style={{ display: 'inline-flex', gap: 1 }}>
      {[1, 2, 3, 4, 5].map(function(i) {
        return (
          <span key={i} style={{ fontSize: size, color: i <= value ? '#EF9F27' : '#D3D1C7', lineHeight: 1 }}>★</span>
        );
      })}
    </span>
  );
};

// 시간 경과 표시
var getTimeAgo = function(dateStr) {
  if (!dateStr) return '정보 없음';
  var diff = Math.floor((new Date() - new Date(dateStr)) / 1000);
  if (diff < 60) return '방금 전';
  if (diff < 3600) return Math.floor(diff / 60) + '분 전';
  if (diff < 86400) return Math.floor(diff / 3600) + '시간 전';
  return Math.floor(diff / 86400) + '일 전';
};

// ─── 평가사 상세 프로필 ───
function InspectorDetail(props) {
  var inspector = props.inspector;
  var onBack = props.onBack;
  var onUpdate = props.onUpdate;

  var avg = inspector.avg_rating;
  var reviews = inspector.reviews || [];
  var scores = inspector.avg_scores || {};
  var distrib = inspector.distribution || [];
  var [editing, setEditing] = useState(false);
  var [editForm, setEditForm] = useState({ name: inspector.name || '', phone: inspector.phone || '', area: inspector.area || '', pin_code: inspector.pin_code || '', status: inspector.status || 'active', telegram_chat_id: inspector.telegram_chat_id || '' });
  var maxCount = Math.max.apply(null, distrib.map(function(d) { return d.count; }).concat([1]));

  var barColor = function(val) { return val >= 4.5 ? '#1D9E75' : val >= 3.5 ? '#EF9F27' : '#E24B4A'; };

  var cardStyle = {
    background: '#fff', borderRadius: 14, border: '1px solid #eee',
    padding: 18, marginBottom: 12,
  };

  // 등급까지 남은 수치 계산
  var nextLevel = inspector.level === '일반' ? '시니어' : inspector.level === '시니어' ? '마스터' : null;
  var nextReq = nextLevel === '시니어' ? { jobs: 50, rating: 4.0 } : nextLevel === '마스터' ? { jobs: 100, rating: 4.5 } : null;

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: '16px 12px' }}>
      <button onClick={onBack} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        fontSize: 15, color: '#3B8BD4', padding: 0, marginBottom: 14, fontWeight: 600,
      }}>← 평가사 목록</button>

      {/* 프로필 헤더 */}
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
          <div style={{
            width: 60, height: 60, borderRadius: '50%',
            background: avg >= 4.5 ? '#FAECE7' : avg >= 3.5 ? '#EEEDFE' : '#F1EFE8',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, fontWeight: 800,
            color: avg >= 4.5 ? '#D85A30' : avg >= 3.5 ? '#534AB7' : '#888780',
          }}>{inspector.name[0]}</div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <span style={{ fontSize: 22, fontWeight: 800, color: '#111' }}>{inspector.name}</span>
              <LvBadge level={inspector.level} />
            </div>
            <div style={{ fontSize: 13, color: '#888' }}>{inspector.area} · {inspector.phone}</div>
            <div style={{ fontSize: 12, color: '#aaa', marginTop: 2 }}>
              가입: {inspector.join_date || inspector.created_at?.slice(0, 10) || '-'} · 상태: {inspector.status === 'active' ? '활동중' : '비활성'}
            </div>
          </div>
          {onUpdate && <button onClick={function() { setEditing(!editing); }} style={{ padding: '6px 14px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', color: '#666', fontSize: 12, cursor: 'pointer', alignSelf: 'flex-start' }}>수정</button>}
        </div>

        {/* 수정 폼 */}
        {editing && (
          <div style={{ marginTop: 14, padding: 14, background: '#f8f8f5', borderRadius: 10 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
              <div><label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>이름</label><input value={editForm.name} onChange={function(e) { setEditForm(Object.assign({}, editForm, { name: e.target.value })); }} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>
              <div><label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>전화번호</label><input value={editForm.phone} onChange={function(e) { setEditForm(Object.assign({}, editForm, { phone: e.target.value.replace(/[^0-9]/g, '') })); }} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>
              <div><label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>활동지역</label><input value={editForm.area} onChange={function(e) { setEditForm(Object.assign({}, editForm, { area: e.target.value })); }} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>
              <div><label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>PIN</label><input value={editForm.pin_code} onChange={function(e) { setEditForm(Object.assign({}, editForm, { pin_code: e.target.value })); }} maxLength={4} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>
              <div style={{ gridColumn: '1 / -1' }}><label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>텔레그램 Chat ID</label><input value={editForm.telegram_chat_id} onChange={function(e) { setEditForm(Object.assign({}, editForm, { telegram_chat_id: e.target.value })); }} placeholder="봇에 /start 후 받은 숫자" style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
                <input type="checkbox" checked={editForm.status === 'active'} onChange={function(e) { setEditForm(Object.assign({}, editForm, { status: e.target.checked ? 'active' : 'inactive' })); }} />
                활성 상태
              </label>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={function() { setEditing(false); }} style={{ padding: '7px 14px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', color: '#666', fontSize: 12, cursor: 'pointer' }}>취소</button>
                <button onClick={function() { onUpdate(inspector.id, editForm); setEditing(false); }} style={{ padding: '7px 14px', borderRadius: 6, border: 'none', background: '#3B8BD4', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>저장</button>
              </div>
            </div>
          </div>
        )}

        {/* 핵심 지표 */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8 }}>
          {[
            [avg, '평균 평점', '#EF9F27'],
            [inspector.total_jobs, '총 검차', '#222'],
            [inspector.recent_jobs, '최근 30일', '#3B8BD4'],
            [reviews.length, '리뷰 수', '#222'],
          ].map(function(item, i) {
            var val = item[0];
            var label = item[1];
            var color = item[2];
            return (
              <div key={i} style={{ background: '#f8f8f5', borderRadius: 10, padding: '10px 0', textAlign: 'center' }}>
                <div style={{ fontSize: 22, fontWeight: 800, color: color }}>{val}</div>
                <div style={{ fontSize: 10, color: '#aaa' }}>{label}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 현재 위치 */}
      {inspector.current_lat && inspector.current_lng && (
        <div style={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#222' }}>현재 위치</div>
              <div style={{ fontSize: 11, color: '#888' }}>{getTimeAgo(inspector.location_updated_at)}</div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <a href={'https://map.naver.com/v5/?c=' + inspector.current_lng + ',' + inspector.current_lat + ',15,0,0,0,dh'}
                target="_blank" rel="noopener noreferrer"
                style={{ padding: '6px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: '#1EC800', color: '#fff', textDecoration: 'none' }}>네이버지도</a>
              <a href={'https://map.kakao.com/?urlX=' + inspector.current_lng + '&urlY=' + inspector.current_lat + '&urlLevel=3&map_type=TYPE_MAP'}
                target="_blank" rel="noopener noreferrer"
                style={{ padding: '6px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: '#FEE500', color: '#3C1E1E', textDecoration: 'none' }}>카카오맵</a>
            </div>
          </div>
        </div>
      )}

      {/* 항목별 평점 */}
      <div style={cardStyle}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: '#222' }}>항목별 평점</div>
        {[
          ['신속성', scores.speed, '일정 준수, 콜 수락 후 검차까지 속도'],
          ['정확성', scores.accuracy, '도막 측정, 사고이력 판단 정확도'],
          ['꼼꼼함', scores.detail, '사진 수량/품질, 메모 상세도'],
        ].map(function(item) {
          var label = item[0];
          var val = item[1];
          var desc = item[2];
          return (
            <div key={label} style={{ marginBottom: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                <div>
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#222' }}>{label}</span>
                  <span style={{ fontSize: 11, color: '#aaa', marginLeft: 6 }}>{desc}</span>
                </div>
                <span style={{ fontSize: 16, fontWeight: 800, color: barColor(val) }}>{val}</span>
              </div>
              <div style={{ height: 8, borderRadius: 4, background: '#f0f0ec' }}>
                <div style={{
                  height: 8, borderRadius: 4, background: barColor(val),
                  width: ((val / 5) * 100) + '%', transition: 'width 0.5s ease',
                }} />
              </div>
            </div>
          );
        })}
      </div>

      {/* 평점 분포 */}
      <div style={cardStyle}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: '#222' }}>평점 분포</div>
        {distrib.map(function(d) {
          return (
            <div key={d.score} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#EF9F27', width: 20, textAlign: 'right' }}>{d.score}★</span>
              <div style={{ flex: 1, height: 10, borderRadius: 5, background: '#f0f0ec' }}>
                <div style={{
                  height: 10, borderRadius: 5, background: '#EF9F27',
                  width: ((d.count / maxCount) * 100) + '%', transition: 'width 0.5s ease',
                }} />
              </div>
              <span style={{ fontSize: 12, color: '#888', width: 24, textAlign: 'right' }}>{d.count}건</span>
            </div>
          );
        })}
      </div>

      {/* 등급 진행 */}
      <div style={cardStyle}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: '#222' }}>등급 시스템</div>
        {Object.entries(LEVELS).map(function(entry) {
          var lv = entry[0];
          var cfg = entry[1];
          var isCurrent = inspector.level === lv;
          return (
            <div key={lv} style={{
              display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px',
              background: isCurrent ? cfg.bg : 'transparent',
              borderRadius: 10, marginBottom: 4,
              border: isCurrent ? '1.5px solid ' + cfg.color : '1px solid transparent',
            }}>
              <LvBadge level={lv} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: isCurrent ? cfg.color : '#666' }}>{cfg.desc}</div>
                <div style={{ fontSize: 11, color: isCurrent ? cfg.color : '#aaa' }}>{cfg.benefit}</div>
              </div>
              {isCurrent && <span style={{ fontSize: 12, fontWeight: 700, color: cfg.color }}>현재</span>}
            </div>
          );
        })}

        {/* 다음 등급까지 */}
        {nextLevel && nextReq && (
          <div style={{
            marginTop: 10, padding: '10px 14px', background: '#f8f8f5',
            borderRadius: 10, fontSize: 12, color: '#666', lineHeight: 1.6,
          }}>
            <strong style={{ color: '#222' }}>{nextLevel}</strong>까지:
            검차 <strong style={{ color: inspector.total_jobs >= nextReq.jobs ? '#1D9E75' : '#E24B4A' }}>
              {inspector.total_jobs}/{nextReq.jobs}건
              {inspector.total_jobs >= nextReq.jobs ? ' ✓' : ' (' + (nextReq.jobs - inspector.total_jobs) + '건 남음)'}
            </strong>,
            평점 <strong style={{ color: avg >= nextReq.rating ? '#1D9E75' : '#E24B4A' }}>
              {avg}/{nextReq.rating}
              {avg >= nextReq.rating ? ' ✓' : ' (+' + (nextReq.rating - avg).toFixed(1) + ' 필요)'}
            </strong>
          </div>
        )}
      </div>

      {/* 최근 리뷰 */}
      <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 12, color: '#222' }}>
        최근 리뷰 ({reviews.length}건)
      </div>
      {reviews.map(function(r) {
        return (
          <div key={r.id} style={cardStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <Stars value={r.score} size={15} />
              <span style={{ fontSize: 11, color: '#aaa' }}>{r.date}</span>
            </div>
            <div style={{ fontSize: 12, color: '#3B8BD4', marginBottom: 4, fontWeight: 500 }}>
              {r.order_no} · {r.car}
            </div>
            {r.comment && (
              <div style={{ fontSize: 13, color: '#444', lineHeight: 1.6 }}>{r.comment}</div>
            )}
            <div style={{ fontSize: 10, color: '#aaa', marginTop: 6, display: 'flex', gap: 10 }}>
              <span>신속 {r.speed}★</span>
              <span>정확 {r.accuracy}★</span>
              <span>꼼꼼 {r.detail}★</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default InspectorDetail;
